const typeNames = {
  TOGGLE_DEVICE: "TOGGLE_DEVICE",
  SET_GIFT_CARDS: "SET_GIFT_CARDS",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  CLOSE_SIDEBAR: "CLOSE_SIDEBAR"
};

const state = {
  giftCards: [],
  device: "desktop",
  sidebar: {
    opened: true,
    withoutAnimation: false
  },
};

const mutations = {
  [typeNames.TOGGLE_SIDEBAR]: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
  },
  [typeNames.CLOSE_SIDEBAR]: (state, withoutAnimation) => {
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  [typeNames.TOGGLE_DEVICE]: (state, device) => {
    state.device = device;
  },
  [typeNames.SET_GIFT_CARDS]: (state, giftCards) => {
    state.giftCards = giftCards;
  },
};

const actions = {
  toggleSideBar({ commit }) {
    commit(typeNames.TOGGLE_SIDEBAR)
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit(typeNames.CLOSE_SIDEBAR, withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit(typeNames.TOGGLE_DEVICE, device);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
